import { ErrorCode } from '../core/errorCodes';

const NON_RETRY_AUTH = new Set<string>([
  ErrorCode.INSUFFICIENT_WALLET_BALANCE,
  ErrorCode.AUTH_REQUIRED,
  ErrorCode.TOKEN_INVALID,
  ErrorCode.TOKEN_MISSING,
  ErrorCode.INSUFFICIENT_SCOPE,
]);

export function isRetryableHttpStatus(status?: number): boolean {
  if (status === undefined) return false;
  return status === 408 || status === 429 || status >= 500;
}

export function isRetryableError(code: string | undefined, httpStatus?: number): boolean {
  if (code && NON_RETRY_AUTH.has(code)) return false;
  return isRetryableHttpStatus(httpStatus);
}
